import { Wrapper, Item } from './TagsGridLayout.styled'

type TagsGridLayoutProps = {
  children: Array<React.ReactNode> | React.ReactNode
}

const TagsGridLayout: React.FC<TagsGridLayoutProps> = ({ children }) => {
  function renderItems() {
    if (!children) return null

    const normalizedChildren = Array.isArray(children) ? children : [children]

    return normalizedChildren.map((item: any, index: number) => <Item key={index}>{item}</Item>)
  }

  return <Wrapper data-test='TagsGridLayout'>{renderItems()}</Wrapper>
}

export default TagsGridLayout
